import { StackScrollTool } from "@cornerstonejs/tools";
import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import DropDown from "../../../../../components/SVGComponents/Tools/DropDown";
import { isMobile } from "react-device-detect";
import { STACK_SCROLL_DROPDOWN_ELEMENTS } from "../../../../../constants/Constants";
import themeContext from "../../../../../context/theme/ThemeContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import StackScroll from "../../../../../components/SVGComponents/Tools/StackScroll";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import userContext from "../../../../../context/users/UserContext";
import { toolTipStyles } from "../../../styles/styles";
import { t } from "i18next";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
import { useTranslation } from "react-i18next";
import {
  createMouseButtonAssignmentPointerDownCaptureHandler,
  suppressMouseButtonAssignmentContextMenu,
  ToolbarMouseAssignmentIndicators,
} from "./mouseButtonToolbarUtils";

const StackScrollToolComponent = ({ tool }) => {
  const { stackSize } = useContext(studyviewerContext);
  const {
    activeThumbnailIndex,
    setStackScrollActiveThumbnailIndex,
    stackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);
  const dropDownRef = useRef(null);
  const buttonRef = useRef(null);
  const [menuPos, setMenuPos] = useState({ bottom: 0, left: 0 });
  const { theme } = useContext(themeContext);
  const [showDropDown, setShowDropDown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const {
    activeTool,
    setActiveTool,
    setPreviousActiveTool,
    activeMPRTool,
    isMPRActive,
    handleDefaultToolChange,
    boundingBoxMode,
    setBoundingBoxMode ,
    isCropEnable,
    setIsCropEnable,
    isSeriesScrollEnabled,
    setIsSeriesScrollEnabled,
    assignMouseButtonToAssignableTool,
    mouseButtonToolAssignments,
  } = useContext(ViewportContext);
  const { username } = useContext(userContext);
  const { t: translate } = useTranslation();
  const [seriesScrollHovered, setSeriesScrollHovered] = useState(false);
  const changeActiveTool = async (toolName) => {
    // eventTarget.reset();
    const isBBMode = boundingBoxMode;
    const isCropMode =  isCropEnable;

    setIsCropEnable(false);
    setBoundingBoxMode(false);
    
    if (!isBBMode && !isCropMode && activeTool === toolName) {
      setPreviousActiveTool(activeTool);
      handleDefaultToolChange();
    } else {
      setPreviousActiveTool(activeTool);
      assignMouseButtonToAssignableTool("primary", toolName, true);
      setActiveTool(toolName);
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleDropDownClick = () => {
    if (!showDropDown && isMobile && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({ bottom: window.innerHeight - rect.top + 6, left: rect.left });
    }
    setShowDropDown(!showDropDown);
    // changeActiveTool(toolName);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleSeriesChange = async (key) => {
    if (key === STACK_SCROLL_DROPDOWN_ELEMENTS[0].key) {
      if (stackSize === 1 || activeThumbnailIndex === 0) {
        return;
      } else {
        setStackScrollActiveThumbnailIndex(activeThumbnailIndex - 1);
      }
    } else if (key === STACK_SCROLL_DROPDOWN_ELEMENTS[1].key) {
      if (activeThumbnailIndex === stackSize - 1) {
        return;
      } else {
        setStackScrollActiveThumbnailIndex(activeThumbnailIndex + 1);
      }
    }
    setShowDropDown(false);
  };

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            ref={buttonRef}
            style={{
              height: "100%",
              width: `${isMobile ? "60px" : "100%"}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: isMobile ? "65%" : "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className={
                  isMobile ? "highlight-tool-mobile" : "highlight-tool"
                }
                style={{
                  width:
                    isMPRActive || isMobile ? undefined : "55px",
                }}
              >
                <CustomToolTipHost
                  delay={TooltipDelay.zero}
                  id={"stackscroll"}
                  directionalHint={DirectionalHint.rightCenter}
                  styles={toolTipStyles}
                  content={isMobile ? "" : t("viewer.tools.stack-scroll")}
                  className={"myToolTip"}
                >
                  <div
                    className={!isMobile ? "tool-with-mouse" : ""}
                    style={{
                      height: "100%",
                      position: "relative",
                    }}
                    onClick={() => changeActiveTool(StackScrollTool.toolName)}
                    onPointerDownCapture={createMouseButtonAssignmentPointerDownCaptureHandler(
                      StackScrollTool.toolName,
                      assignMouseButtonToAssignableTool
                    )}
                    onContextMenu={suppressMouseButtonAssignmentContextMenu}
                    onContextMenuCapture={suppressMouseButtonAssignmentContextMenu}
                    onMouseOver={handleMouseOver}
                    onMouseLeave={handleMouseLeave}
                  >
                    <StackScroll
                      color={
                        (isMPRActive &&
                          activeMPRTool === StackScrollTool.toolName) ||
                        activeTool === StackScrollTool.toolName ||
                        (!isMobile && hovered)
                          ? theme.palette.activeTool
                          : theme.palette.inactiveTool
                      }
                    />
                    {!isMobile && (
                      <ToolbarMouseAssignmentIndicators
                        toolName={StackScrollTool.toolName}
                        assignments={mouseButtonToolAssignments}
                      />
                    )}
                  </div>
                </CustomToolTipHost>
                {!isMPRActive && (
                  <div
                    style={{
                      // Wider than the Rotation/HP tools' 4px gap: on desktop this icon can
                      // show the mouse-button assignment badge (bottom-right corner, protrudes
                      // ~9px past the icon), which would otherwise overlap the arrow. The badge
                      // never renders on mobile, so mobile keeps the tighter gap.
                      marginLeft: isMobile ? "4px" : "14px",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}
                    onClick={handleDropDownClick}
                    onMouseOver={() => setDropDownHovered(true)}
                    onMouseLeave={() => setDropDownHovered(false)}
                  >
                    <DropDown up={isMobile}
                      color={
                        dropDownHovered || hovered
                          ? theme.palette.activeTool
                          : theme.palette.inactiveTool
                      }
                    />
                  </div>
                )}
              </div>
            </div>
            {isMobile && (
              <span
                style={{
                  fontSize: "9px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  //color: "#FFFFFF",
                  //color: "var(--navbar-header-popup-color-txt)",
                  color: "var(--mobile-color-txt)",
                }}
              >
                {t("viewer.tools.stack-scroll-mobile")}
              </span>
            )}
          </div>
        </div>

        {showDropDown && (
          <div
            className={
              isMobile ? "viewer-tool-more-dropdown" : "dropdow-top-position viewer-tool-more-dropdown"
            }
            ref={dropDownRef}
            style={{
              flexDirection: "column",
              position: isMobile ? "fixed" : "absolute",
              ...(isMobile ? { bottom: menuPos.bottom, left: menuPos.left } : {}),
              // top : window.innerHeight * 0.075,
              zIndex: "999",
              // backgroundColor: "#201F1E",
              boxShadow:
                "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
              borderRadius: "5px",
              paddingLeft: "10px",
              paddingRight: "20px",
            }}
          >
            {STACK_SCROLL_DROPDOWN_ELEMENTS.map((ss, index) => {
              return (
                <div
                  key={index}
                  onClick={() => handleSeriesChange(ss.key)}
                  className={`stack-scroll-dropdown-elements ${
                    (index === 0 && activeThumbnailIndex === 0) ||
                    (index === 1 && activeThumbnailIndex === stackSize - 1)
                      ? "stack-scroll-dropdown-elements-disabled"
                      : ""
                  }`}
                >
                  {ss.key}
                </div>
              );
            })}
            <div
              style={{
                borderTop: "1px solid #585858",
                marginTop: "4px",
                paddingTop: "4px",
              }}
            >
              <div
                className={`stack-scroll-dropdown-elements ${seriesScrollHovered ? "hovered" : ""}`}
                onMouseOver={() => setSeriesScrollHovered(true)}
                onMouseLeave={() => setSeriesScrollHovered(false)}
                onClick={() => setIsSeriesScrollEnabled(!isSeriesScrollEnabled)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  cursor: "pointer",
                }}
              >
                <span>{translate("viewer.tools.scroll-through-series", "Scroll Through Series")}</span>
                <span
                  style={{
                    display: "inline-block",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: isSeriesScrollEnabled ? "#0078d4" : "#585858",
                    border: isSeriesScrollEnabled ? "none" : "1px solid #888",
                    flexShrink: 0,
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StackScrollToolComponent;
